import { useMemo } from 'react'

import type { PaginationProps } from './pagination.types'

import { PaginationControl } from './components/pagination-control'
import { PaginationEllipse } from './components/pagination-ellipse'
import { PaginationItem } from './components/pagination-item'

export const Pagination = ({
  current,
  total,
  pagesMapper,
  onPageClick,
  prevControl,
  nextControl,
}: PaginationProps) => {
  const pagesToRender = useMemo(() => {
    const values = new Set([1, Number(current), Number(total)])
    const items = Array.from(values)?.map(item => ({
      id: item,
      page: pagesMapper?.[item - 1],
    }))

    return items?.filter(item => !!item?.page)
  }, [current, total, pagesMapper])

  return (
    <nav className="flex flex-row items-center gap-[var(--spacing-inline-twopulse)] max-sm:gap-[var(--spacing-inline-threepulse)]">
      <PaginationControl
        testID={prevControl?.testID}
        control={prevControl}
        disabled={current === 1}
        aria-label="Anterior"
      >
        Anterior
      </PaginationControl>

      <ol className="flex flex-row items-center justify-start gap-[var(--spacing-inline-onepulse)]">
        {pagesToRender.map(({ id, page }, index) => {
          const hasCurrent = id === current

          const oldPage = pagesToRender?.[index - 1]

          const showEllipse = !!oldPage && id - oldPage?.id > 1

          return [
            showEllipse && <PaginationEllipse key={`${id}-ellipse`} />,
            <PaginationItem
              testID={page?.testID}
              key={id}
              item={id}
              hasCurrent={hasCurrent}
              href={page?.href}
              onClick={() => onPageClick?.(id)}
            />,
          ]
        })}
      </ol>

      <PaginationControl
        control={nextControl}
        disabled={current === total}
        testID={nextControl?.testID}
        aria-label="Próximo"
      >
        Próximo
      </PaginationControl>
    </nav>
  )
}
